import type { ApprovedCodeView, DesignationView } from "../types";

export type DesignationPart = DesignationView["parts"][number];

export type ReadsAsLookup = Map<string, string>;

export const PART_LABELS: Record<DesignationPart["slotName"], string> = {
  Base: "Base",
  Origin: "Recycle",
  Filler: "Filler",
  Additive: "Additive",
  Color: "Color",
};

function lookupKey(standardCode: string, slotName: string, code: string): string {
  return `${standardCode}|${slotName}|${code}`;
}

export function readsAsLookup(approvedCodes: ApprovedCodeView[]): ReadsAsLookup {
  return new Map(
    approvedCodes.map((approvedCode) => [
      lookupKey(approvedCode.standardCode, approvedCode.slotName, approvedCode.code),
      approvedCode.readsAs,
    ]),
  );
}

export function partMeaning(part: DesignationPart, standardCode: string, readsAsByCode: ReadsAsLookup): string {
  const pieces = [];
  const readsAs = readsAsByCode.get(lookupKey(standardCode, part.slotName, part.code));
  if (readsAs) pieces.push(readsAs);
  if (part.percentByWeight != null) pieces.push(`${part.percentByWeight}% by weight`);
  if (part.qualifierText) pieces.push(`Qualifier ${part.qualifierText}`);
  return pieces.join(" · ") || "—";
}
